import _ from 'lodash';
import { PETS } from '../constants';

import getStorage from './getStorage';
import getRandom from './getRandom';
import getNewGoody from './getNewGoody';
import shuffleActiveGoodies from './shuffleActiveGoodies';
import shuffleActivePetType from './shuffleActivePetType';
import saveToStorage from './saveToStorage';
import getCollectedPetTypes from '../selectors/getCollectedPetTypes';


// --- STEP 1: GET STORAGE --- //

const newState = getStorage();


// --- STEP 2: SET VISITS & TIMESTAMP --- //

export function setVisits() {
	newState.visits++;

	saveToStorage.visits(newState);

	return newState.visits;
}


export function setLastVerification() {
	return newState.lastVerification;
}


// --- STEP 3: SET PETS --- //

export function setAllPets() {
	newState.allPets = _.uniqBy(newState.allPets, 'sku'); // Remove duplicates.

	saveToStorage.allPets(newState);

	return newState.allPets;
}

export function setActivePet() {
	const collectedPetTypes = getCollectedPetTypes(newState.allPets);
	// Object to check against constants. We only need the sku.
	const findCriteria = { sku: _.get(newState.activePet.active.petType, 'sku') };
	const activePetShouldntBeActive = !_.find(PETS, findCriteria) || // It doesnt exist
		!_.find(collectedPetTypes, findCriteria); // It isn't collected

	let transientPetAttributes = {};

	// If shuffle is on or the current pet doesn't exist,
	// shuffle the active pet.
	if (newState.activePet.shuffle || activePetShouldntBeActive) {
		newState.activePet.active.petType = shuffleActivePetType(collectedPetTypes);
	}

	// If we shuffled the pet because the current one didn't exist,
	// set shuffle to true to explain why the pet changed.
	if (activePetShouldntBeActive && collectedPetTypes.length > 1) {
		newState.activePet.shuffle = true;
	}

	saveToStorage.activePet(newState);
	transientPetAttributes = getRandom.petOfTypeForInitialize(newState.activePet.active.petType.type);

	return {
		...newState.activePet,
		active: {
			...newState.activePet.active,
			...transientPetAttributes,
			kitten: null, // Remove kitten to reset kitten chances on load.
		},
	};
}


// --- STEP 4: SET GOODIES --- //

export function setCollectedGoodies() {

	const shouldGetNewGoody = newState.visits === 1 || newState.visits % 200 === 0 || Math.random() < 0.005;

	if (shouldGetNewGoody) {
		// get a new goody.
		const newGoody = getNewGoody(
			getCollectedPetTypes(newState.allPets),
			newState.collectedGoodies.list,
		);

		if (newGoody) {
			// add it to collected goodies, list and new.
			newState.collectedGoodies.list.push(newGoody.id);
			newState.collectedGoodies.newItems.push(newGoody.id);

			// set this new goody to active.
			newState.activeGoodies.active[newGoody.type] = newGoody.id;
		}
	}

	saveToStorage.collectedGoodies(newState);

	return newState.collectedGoodies;
}


export function setActiveGoodies() {

	if (newState.activeGoodies.shuffle) {
		newState.activeGoodies.active = shuffleActiveGoodies(newState.collectedGoodies.list);
	}

	saveToStorage.activeGoodies(newState);

	return newState.activeGoodies;
}



// WEBPACK FOOTER //
// ./src/utils/initialize.js